import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoadingCinematic from './components/LoadingCinematic';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import PianoGallery from './components/PianoGallery';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PianoNumeriquesNeufs from './components/PianoNumeriquesNeufs';
import PianoQueueDroitNeufs from './components/PianoQueueDroitNeufs';
import PianoNumeriquesOccasion from './components/PianoNumeriquesOccasion';
import PianoAcoustiquesOccasion from './components/PianoAcoustiquesOccasion';
import ServicesPage from './components/ServicesPage';
import LocationsPage from './components/LocationsPage';
import GalleryPage from './components/GalleryPage';
import HistoirePage from './components/HistoirePage';
import MentionsLegales from './components/MentionsLegales';
import ImageReference from './components/ImageReference';

// Composant pour gérer le scroll vers les ancres
const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Si il y a une ancre, attendre que le DOM soit rendu puis scroller vers l'ancre
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Pour toutes les autres navigations (sans ancre), toujours scroller en haut
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
};

// Composant principal des routes
const AppRoutes = () => {
  return (
    <>
      <ScrollToAnchor />
      <Header />
      <Routes>
        <Route path="/" element={
          <main>
            <Hero />
            <Services />
            <PianoGallery />
            <Contact />
          </main>
        } />
        <Route path="/pianos-numeriques-neufs" element={<PianoNumeriquesNeufs />} />
        <Route path="/pianos-queue-droit-neufs" element={<PianoQueueDroitNeufs />} />
        <Route path="/pianos-numeriques-occasion" element={<PianoNumeriquesOccasion />} />
        <Route path="/pianos-acoustiques-occasion" element={<PianoAcoustiquesOccasion />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/galerie" element={<GalleryPage />} />
        <Route path="/histoire" element={<HistoirePage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/images-reference" element={<ImageReference />} />
      </Routes>
      <Footer />
    </>
  );
};

function App() {
  const [showLoading, setShowLoading] = useState(() => {
    // Ne montrer le loading que si c'est le premier chargement
    return !sessionStorage.getItem('hasLoadedBefore');
  });

  useEffect(() => {
    // Marquer que l'application a déjà été chargée
    if (!sessionStorage.getItem('hasLoadedBefore')) {
      sessionStorage.setItem('hasLoadedBefore', 'true');
    }
  }, []);

  const handleLoadingComplete = () => {
    setShowLoading(false);
  };

  if (showLoading) {
    return <LoadingCinematic onComplete={handleLoadingComplete} />;
  }

  return (
    <Router>
      <div className="min-h-screen">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;